import { useEffect, useState } from "react";

export interface CoWorkerPreferences {
  buCode?: string;
  cmpCode?: string;
  language?: string;
}
export function useSyncCoworker() {
  const [preferences, setPreferences] = useState<
    CoWorkerPreferences | undefined
  >(undefined);

  const updateCoworkerProfile = (event: any) => {
    if (event?.detail?.buCode) {
      setPreferences({
        buCode: event?.detail?.buCode,
        cmpCode: event?.detail?.coworkerMeetingPoint,
        language: event?.detail?.language,
      });
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setPreferences({
        ...(window?.salja?.coworkerprofile?.data?.coworkerPreferences ?? {}),
      });
      window?.salja?.coworkerprofile?.events?.coworkerPreferences?.subscribe(
        updateCoworkerProfile
      );
    }, 1500);
    return () => {
      clearTimeout(timer);
      window?.salja?.coworkerprofile?.events?.coworkerPreferences?.unsubscribe(
        updateCoworkerProfile
      );
    };
  }, []);

  return preferences;
}
